module.exports = __webpack_public_path__ + "img/38.fe167bd2.png";